import { merge } from 'lodash';
import { evaluateUserFlag, UserMachine } from '~/machines/user-creation';
import { ContextSendMatch } from '~/machines/utils/types';
import { DeepPartial } from '~/typings/utils';
import { CreateAccountGoogle, CreateAccountGoogleProps } from './create-account-google.component';

type CreateAccountGoogleContainerProps = {
  micro: ContextSendMatch<UserMachine>;
  overrideCopy?: CreateAccountGoogleProps['overrideCopy'];
  overrideProps?: DeepPartial<CreateAccountGoogleProps>;
};

export const CreateAccountGoogleContainer = ({
  micro: { context, matches, send },
  overrideCopy,
  overrideProps,
}: CreateAccountGoogleContainerProps) => {
  const props: CreateAccountGoogleProps = {
    context: {
      businessName: context.businessName,
      googleUser: context.googleUser!,
      inviteCode: context.inviteCode,
      phone: context.phone,
      optInToSMS: context.optInToSMS,
      promoCode: context.promoCode,
      utility: context.utility,
      zipCode: context.zipCode,
    },
    error: context.errors.google,
    flags: {
      requireBusinessName: evaluateUserFlag(context, 'requireBusinessName'),
      requirePhone: evaluateUserFlag(context, 'requirePhone'),
      showPhone: evaluateUserFlag(context, 'showPhone'),
      showInviteCode: evaluateUserFlag(context, 'showInviteCode'),
    },
    goTo: {
      utility: () => send({ type: 'CHANGE_UTILITY' }),
    },
    next: data => send({ type: 'SUBMIT_USER', data }),
    overrideCopy,
    pending: matches('google.submitting'),
  };

  return <CreateAccountGoogle {...merge(props, overrideProps)} />;
};
